// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminGuaranteeSearchResponse

import { hydrateAdminGuaranteeListItem, type AdminGuaranteeListItem, type AdminGuaranteeListItemApiResponse } from './adminGuaranteeListItem.gen';

export type AdminGuaranteeSearchApiResponse = {
	items: AdminGuaranteeListItemApiResponse[];
};

export type AdminGuaranteeSearch = {
	items: AdminGuaranteeListItem[];
};

export function hydrateAdminGuaranteeSearch(data: AdminGuaranteeSearchApiResponse): AdminGuaranteeSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminGuaranteeListItem),
	};
}